import { eventBus } from '@/main'

export default class ErrorHandler {
  constructor(response, fallbackRoute) {
    if (fallbackRoute) { eventBus.$emit('sendUserToRoute', fallbackRoute) }
    this._emitErrorMessage(response)
  }

  _emitErrorMessage (response) {
    return response.clone().json().then(responseBody => {
      eventBus.$emit('setErrorCodeAnnouncement', {
        userMessage: responseBody.userMessage,
        isError: true
      })
    })
  }
}
